import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Button } from '@mui/material';

import { IMedicationSearchResultCardProps } from './MedicationSearchResultCard.interface';

import './style.scss';

const MedicationSearchResultCard: FC<IMedicationSearchResultCardProps> = ({
  prescription,
  isBanned,
  bannedText,
  notBannedText,
  bannedDrugClasses,
  isShowMedicationExceptionLink,
  linkHref,
  linkTitle,
}) => {
  const { t } = useTranslation();

  const showLink = isShowMedicationExceptionLink && isBanned && linkHref && linkTitle;

  return (
    <Box className="search-result-card">
      <Box className="search-result-card__section">
        <p className="search-result-card__title overline">{t('medicationLookup.prescription')}</p>
        <h4>{prescription}</h4>
      </Box>

      <Box className="search-result-card__section">
        <p className="search-result-card__title overline">
          {t('medicationLookup.medicationStatus')}
        </p>

        <Box className="search-result-card__status">
          {isBanned ? (
            <>
              <CancelOutlinedIcon color="error" />
              <h6>{bannedText}</h6>
            </>
          ) : (
            <>
              <CheckCircleOutlineIcon color="success" />
              <h6>{notBannedText}</h6>
            </>
          )}
        </Box>
      </Box>

      {isBanned && !!bannedDrugClasses?.length && (
        <Box className="search-result-card__section">
          <p className="search-result-card__title overline">
            {t('medicationLookup.bannedDrugClasses')}
          </p>
          {bannedDrugClasses.map((drugClass, index) => (
            <h6 key={index} className="search-result-card__line-height">
              {drugClass}
              {bannedDrugClasses.length - 1 !== index && ', '}
            </h6>
          ))}
        </Box>
      )}

      {(!isBanned || showLink) && (
        <>
          <Box className="search-result-card__divider" />

          <Box className="search-result-card__section">
            <Box className="search-result-card__status">
              <HelpOutlineIcon color="success" />
              <p className="caption">
                {isBanned
                  ? t('medicationLookup.whatIfBanned')
                  : t('medicationLookup.reportAllMedicationsText')}
              </p>
            </Box>
          </Box>
        </>
      )}

      {showLink && (
        <Box className="search-result-card__status">
          <Button variant="text" href={linkHref} target="_blank">
            <OpenInNewIcon color="success" />
            <span className="search-result-card__button_text">{linkTitle}</span>
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default MedicationSearchResultCard;
